import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupRestrictedActionsOffContentProps } from './msg-group-restricted-actions-off-content';
import { MsgGroupRestrictedActionsOffContent } from './msg-group-restricted-actions-off-content';

export interface MsgGroupRestrictedActionsOffPreviewProps
  extends MsgGroupRestrictedActionsOffContentProps {}

export const MsgGroupRestrictedActionsOffPreview = memo(
  function MsgGroupRestrictedActionsOffPreview({
    message,
  }: MsgGroupRestrictedActionsOffPreviewProps) {
    return (
      <LastMessageSystem>
        <MsgGroupRestrictedActionsOffContent message={message} />
      </LastMessageSystem>
    );
  }
);
